<template>
  <RcDialog :model-value="true" :title="$t('people_profile_switch_back')" :width="mobile ? '100%' : DialogUtils.SMALL" @closeDialog="handleClose" :fullscreen="mobile">
    <p class="my-8 text-center" style="font-size: 1.2em;">
      {{ $t('people_profile_switch_back_confirm') }}
    </p>

    <template #actions>
      <v-btn color="success" variant="flat" @click="handleSwitchBackConfirm">
        {{ $t('people_profile_switch_back') }}
      </v-btn>
    </template>
  </RcDialog>
</template>

<script setup>
import { useDisplay } from 'vuetify';
import RcDialog from '@/v3/components/library/dialog/RcDialog.vue';
import DialogUtils from '@/v3/utils/DialogUtils.js';

const emit = defineEmits(['closeDialog', 'switchBack']);

const { mobile } = useDisplay();

const handleSwitchBackConfirm = () => {
  emit('switchBack');
};

const handleClose = () => {
  emit('closeDialog');
};
</script>
